import React, { Component } from 'react'
import Select from 'antd/lib/select'
import Spin from 'antd/lib/spin'
import debounce from 'lodash.debounce'

class SimpleMultiLocationSearch extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            value: [],
            fetching: false,
        };

        this.lastFetchId = 0;
        this.fetchLocation = debounce(this.fetchLocation, 800);
    }

    fetchLocation = (value) => {
        this.lastFetchId += 1
        const fetchId = this.lastFetchId
        this.setState({ data: [], fetching: true })
        fetch('https://www.meteoblue.com/en/server/search/query3?itemsPerPage=50&query=' + value)
            .then(response => response.json())
            .then((body) => {
                if (fetchId !== this.lastFetchId) { // for fetch callback order
                    return
                }
                const data = body.results.map(location => ({
                    text: `${location.name}, ${location.admin1}, ${location.iso2}`,
                    title: `${location.lat}, ${location.lon}, ${location.asl} asl, \n` +
                        `Time zone: ${location.timezone}, Population: ${location.population}`,
                    value: location.lon + '/' + location.lat + '/' + location.asl + '%' + location.name,
                }))
                this.setState({ data, fetching: false })
            })
    }

    handleLocationSearchChange = (value) => {
        this.setState({
            value,
            data: [],
            fetching: false,
        })
        if(this.props.callback) {
            this.props.callback()
        }
    }

    render() {
        return (
            <React.Fragment>
                {/* TODO: open dropdown on focus  */}
                {this.props.antForm.getFieldDecorator('locations', {
                    initialValue: this.props.defaultValue
                })(
                    <Select
                        mode="multiple"
                        labelInValue
                        allowClear
                        //value={this.state.value}
                        placeholder="Start typing to search location"
                        notFoundContent={this.state.fetching ? <Spin size="small" /> : null}
                        filterOption={false}
                        onSearch={this.fetchLocation}
                        onChange={ this.handleLocationSearchChange }
                        style={{ width: '100%' }}
                    >
                        {this.state.data.map((d,i) =>
                            <Select.Option
                                key={i}
                                value={d.value + '%' + i} // coordinates + asl alone are not a unique id
                                title={d.title}>{d.text}
                            </Select.Option>
                        )}
                    </Select>
                )}
            </React.Fragment>
        )
    }

}

export default SimpleMultiLocationSearch